<template>
    <div>
        <el-avatar v-loading="loading" style="background-color: transparent"/> <br>
        <label>Loading ...</label>
    </div>
</template>

<script>
    export default {
        name: "LoadingComponent",
        data() {
            return {
                loading: true
            }
        }
    }
</script>

<style scoped>

</style>
